export default () => {
    const pre = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'x']
    return pre[Math.floor(Math.random() * Math.floor(pre.length))] + Math.floor(Math.random() * Math.floor(999)) + '-' + Date.now()
}